// Vendor libraries
import { combineReducers } from '@ngrx/store';
// Utils / Constants
import { createReducerWithAppState } from 'NewAngular/state/app-state/utils';
import { SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY, SEARCH_ALL_PARAMS_SYSTEM_DEFAULT_STATE } from './state/constants';
// NgRx reducers
// Top level reducers
import { appStateSliceKey } from 'NewAngular/state/app-state/app-state.reducer';
import { searchAllParams } from './state/search-all.reducer';
const initialSystemState = {
    [SEARCH_ALL_PARAMS_APP_STATE_SLICE_KEY]: SEARCH_ALL_PARAMS_SYSTEM_DEFAULT_STATE,
};
export const reducers = combineReducers({
    appStateSliceKey,
    searchAllParams,
});
export const rootReducer = createReducerWithAppState(reducers, initialSystemState, {});
